module.exports = __webpack_public_path__ + "img/estalagem19.8c9c8161.jpg";